
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, BreadCrumb } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

@Component({
  components: {
    NavBar,
    BreadCrumb
  }
})
export default class CollectionView extends Vue {
  data () {
    return this.getResetData()
  }

  getResetData () {
    return {
      text: '',
      lines: [],
      expressions: [],
      activeLine: 0,
      playerInterval: null,
      artefato: null,
      collectionId: null,
      articleResults: [],
      articleChosenIndex: null,
      isLoading: false,
      word: null,
      readSpeed: 50,
      authors: '',
      source: ''
    }
  }

  created () {
    this.$multiwatch(['activeLine'], function () {
      if (this.$refs && this.$refs.itemRefs) {
        var item = this.$refs.itemRefs[this.activeLine]
        // item.scrollIntoView()
        item.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
    this.$multiwatch(['readSpeed'], function () {
      if (this.playerInterval) {
        this.pause()
        this.play()
      }
    })
  }

  mounted () {
    this.collectionId = Number(this.$route.params.collectionId)
    if (this.collectionId) {
      this.getArtefatos()
    }
  }

  play () {
    this.playerInterval = setInterval(() => {
      if (this.activeLine === this.lines.length - 1) {
        this.pause()
        this.logDicionarioRead()
        this.logArticleRead()
      } else {
        this.logDicionarioRead()
        this.logContentRead()
        this.activeLine++
      }
    }, (100 - this.readSpeed) * 60)
  }

  pause () {
    clearInterval(this.playerInterval)
    this.playerInterval = null
  }

  async loadText () {
    this.text = this.artefato.content
    var indexes = []
    var vocabulario = this.artefato.dicionario
    for (var i = 0; i < vocabulario.length; i++) {
      var voc = vocabulario[i].dicionario
      indexes = indexes.concat(voc.indexes)
    }
    var wordsPerStripe = 15
    this.lines = []
    this.lines.push([{
      content: '',
      isBtn: false,
      dicionarioId: ''
    }])
    var wordAcc = ''
    var lineWordsAcc = 0
    var line = []
    for (i = 0; i < this.text.length; i++) {
      var idxFound = indexes.findIndex(e => e.s === i)
      var content = ''
      if (idxFound > -1) {
        var wordEnding = ''
        var it = 0
        var regex = /\s|,|\.`/gi
        var notBroken = false
        while (!notBroken && regex.exec(wordEnding) === null) {
          wordEnding = `${wordEnding}${this.text.substring(indexes[idxFound].e + it, indexes[idxFound].e + 1 + it)}`
          it += 1
          if (it === 10) {
            notBroken = true
          }
        }
        wordEnding = wordEnding.substring(0, wordEnding.length - 1)
        content = this.text.substring(i, indexes[idxFound].e)
        var dicionarioIdIdx = vocabulario.findIndex(e => e.dicionario.expression.toLowerCase() === content.toLowerCase())
        content = `${content}${wordEnding}`
        if (dicionarioIdIdx > -1) {
          line.push({
            content,
            isBtn: true,
            dicionarioId: vocabulario[dicionarioIdIdx].dicionarioId
          })
          lineWordsAcc += content.split(' ').length
          i = indexes[idxFound].e - 1 + wordEnding.length
        }
      } else {
        var letter = this.text.substring(i, i + 1)
        content = `${wordAcc}${letter}`
        if ([' ', ',', '.'].includes(letter) && wordAcc !== '.' && wordAcc !== ',' && wordAcc !== ' ') {
          line.push({
            content,
            isBtn: false
          })
          lineWordsAcc += 1
          wordAcc = ''
        } else {
          wordAcc = `${wordAcc}${letter}`
        }
      }
      var nextTwoLetters = this.text.substring(i + 1, i + 2)
      if (lineWordsAcc >= wordsPerStripe) {
        if ([',', '.'].some(e => nextTwoLetters.includes(e))) {
          line.push({
            content: nextTwoLetters,
            isBtn: false
          })
          i = i + nextTwoLetters.length
          wordAcc = ''
        }
        lineWordsAcc = 0
        this.lines.push(line)
        line = []
      }
    }
    if (wordAcc !== '') {
      line.push({
        content: wordAcc,
        isBtn: false
      })
      wordAcc = ''
    }
    if (line.length > 0) {
      this.lines.push(line)
      line = []
    }
    if (this.lines.length > 0) {
      this.goToLine(1)
    } else {
      this.goToLine(0)
    }
  }

  goToLine (index) {
    this.activeLine = index
  }

  getExpression (value) {
    var artefatoId = this.articleResults[this.articleChosenIndex].id
    this.getDicionario(value, artefatoId, this.collectionId)
  }

  async getArtefatos () {
    this.isLoading = true
    try {
      this.articleResults = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getArtefatosByCollectionId/${this.collectionId}`))
      if (this.articleResults.length > 0) {
        this.articleChosenIndex = 0
        await this.loadArticle()
      } else {
        this.articleChosenIndex = null
      }
      this.isLoading = false
    } catch (e) {
      this.articleResults = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get articles.',
        canCancel: false
      })
    }
  }

  async loadArticle () {
    this.isLoading = true
    this.data = this.getResetData()
    try {
      var allIndexes = []
      this.artefato = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getArtefatoByIdIncludeDicionario/${this.articleResults[this.articleChosenIndex].id}`))
      var content = this.artefato.content
      this.authors = this.articleResults[this.articleChosenIndex].authors
      this.source = `https://www.wikihow.com/${this.articleResults[this.articleChosenIndex].reference}`
      this.artefato.dicionario.sort((a, b) => b.dicionario.expression.length - a.dicionario.expression.length)
      for (var i = 0; i < this.artefato.dicionario.length; i++) {
        var exp = this.artefato.dicionario[i].dicionario.expression
        var expVariations = new RegExp(` ${exp} | ${exp}.| ${exp},`, 'gi')
        var matches = []
        var match
        while ((match = expVariations.exec(content)) !== null) {
          matches.push({ value: match[0], s: match.index + 1, e: match.index + 1 + exp.length })
        }
        var indexes = []
        matches.map(match => {
          if (allIndexes.findIndex(included => included.s <= match.s && included.e >= match.e) === -1) {
            var idxs = { s: match.s, e: match.e }
            indexes.push(idxs)
            allIndexes.push(idxs)
          }
          return 0
        })
        this.artefato.dicionario[i].dicionario.indexes = indexes
      }
      await this.loadText()
      this.isLoading = false
    } catch (e) {
      // this.articleResults = []
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get article.',
        canCancel: false
      })
    }
  }

  async getDicionario (dicionarioId, artefatoId, collectionId) {
    this.isLoading = true
    if (this.playerInterval) {
      this.pause()
    }
    try {
      this.word = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getDicionarioById/${dicionarioId}`))
      this.isLoading = false
    } catch (e) {
      this.word = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not get word.',
        canCancel: false
      })
    }
  }

  async logArticleRead () {
    this.isLoading = true
    try {
      await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/read_artefato/${this.articleResults[this.articleChosenIndex].id}/${this.collectionId}`))
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: 'Could not log article read.',
        canCancel: false
      })
    }
  }

  async logContentRead () {
    try {
      var content = this.lines[this.activeLine].map(expr => expr.content).join('').replaceAll('  ', ' ').replaceAll('\n', '').replaceAll('\t', '')
      var data = {
        content,
        artefatoId: this.articleResults[this.articleChosenIndex].id,
        collectionId: this.collectionId
      }
      await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/read_content`, data)
    } catch (e) {
      console.error(e)
    }
  }

  async logDicionarioRead () {
    // this.isLoading = true
    try {
      var data = {
        dicionarioIds: this.lines[this.activeLine].filter(expr => expr.dicionarioId).map(expr => expr.dicionarioId)
      }
      await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/read_dicionarios`, data)
    } catch (e) {
      console.error('Could not log dicionario read.')
    }
  }
}
